module.exports = __webpack_public_path__ + "static/media/icon-order-selected.2520a63d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/icon-order-selected.svg
// module id = 125
// module chunks = 0